import { render } from "./Mitglied.vue?vue&type=template&id=17050447&scoped=true"
import script from "./Mitglied.vue?vue&type=script&lang=js"
export * from "./Mitglied.vue?vue&type=script&lang=js"

import "./Mitglied.vue?vue&type=style&index=0&id=17050447&scoped=true&lang=css"

import exportComponent from "C:\\GIT-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17050447"]])

export default __exports__